import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppSettingsProto, CoreConstants, DefaultAccessModel } from '../core.constants';

@Injectable({
  providedIn: 'root',
})
export class DataStoreService {
  public APP_SETTINGS: Map<string, any> = new Map();
  public defaultAccessVal = new DefaultAccessModel();
  public appSettingsData$: BehaviorSubject<AppSettingsProto> = new BehaviorSubject<AppSettingsProto>(new AppSettingsProto());

  constructor() {
    CoreConstants.rightMask$.subscribe((val) => {
      this.access = val;
    });
  }

  private _dashboardRefresh$ = new BehaviorSubject<boolean>(false);

  get dashboardRefresh$(): BehaviorSubject<any> {
    return this._dashboardRefresh$;
  }

  set dashboardRefresh$(val: BehaviorSubject<any>) {
    this._dashboardRefresh$ = val;
  }

  private _workspaceRefresh$ = new BehaviorSubject<boolean>(false);

  get workspaceRefresh$(): BehaviorSubject<boolean> {
    return this._workspaceRefresh$;
  }

  set workspaceRefresh$(value: BehaviorSubject<boolean>) {
    this._workspaceRefresh$ = value;
  }

  private _appSettingsData: AppSettingsProto = new AppSettingsProto();

  get appSettingsData(): AppSettingsProto {
    return this._appSettingsData;
  }

  set appSettingsData(data: AppSettingsProto) {
    this._appSettingsData = data;

    const keys = Object.keys(data);
    keys.forEach((key) => {
      this.APP_SETTINGS.set(key, data[key]);
    });

    this.appSettingsData$.next(data);
  }

  private _access = {};

  get access(): object {
    return this._access;
  }

  set access(val: object) {
    if (val) {
      this._access = val;
    }
  }

  public accessKey(key: string): DefaultAccessModel {
    return this._access.hasOwnProperty(key) ? this._access[key] : this.defaultAccessVal;
  }
}
